import React from "react";
import { Zap, ZapOff } from "lucide-react";

interface TorchToggleButtonProps {
  hasTorch: boolean;
  torchOn: boolean;
  onToggle: () => void;
}

export const TorchToggleButton: React.FC<TorchToggleButtonProps> = ({
  hasTorch,
  torchOn,
  onToggle,
}) => {
  if (!hasTorch) return null;

  return (
    <button
      onClick={onToggle}
      className={`absolute top-4 left-4 z-50 p-2.5 rounded-full backdrop-blur-md shadow-md border transition-all active:scale-95 cursor-pointer ${
        torchOn
          ? "bg-amber-400 text-slate-900 border-amber-300 shadow-amber-500/50"
          : "bg-white/80 hover:bg-white text-slate-700 hover:text-slate-900 border-slate-200/80"
      }`}
      title={torchOn ? "Turn flashlight off" : "Turn flashlight on"}
    >
      {torchOn ? <Zap className="w-5 h-5 fill-slate-900" /> : <ZapOff className="w-5 h-5" />}
    </button>
  );
};
